define('src/plugins/bootbox.extension',[
    // Libs
    'jquery', 'underscore', 'backbone', 'mustache', 'bootbox', 'utils',
], function(
    // Libs
    $, _, Backbone, Mustache, Bootbox, U
) {

    /**
     * Retrieve the callback and return a new function bound with the context.
     * @param  {Object}   context  to use.
     * @param  {Function|String} callback to bind with context
     * @return {Function}  new bound function.
     */
    function applyContext(context, callback) {
        if (_.isString(callback)) callback = context[callback];
        if (context && _.isFunction(callback)) {
            return callback.bind(context);
        }
        return callback;
    }

    /**
     * Binds the button callbacks with the context.
     * @param  {Object} opt passed to the modal, containing the context and buttons.
     */
    function applyContextToButtons(opt) {
        var context = opt.context,
            buttons = opt.buttons;
        _.each(buttons, function(btn, key) {
            var callback = btn.callback;
            if (callback) {
                btn.callback = applyContext(context, callback);
            } else if (_.isFunction(btn)) {
                buttons[key] = applyContext(context, btn);
            }
        });
    }

    /**
     * Applies the context to all possible callbacks if the context is provided.
     * @param  {Object} opt to handle
     * @return {Object} the same options, with each callback bound to the context.
     */
    function handleOptions(opt) {
        var context = opt.context;
        if (context) {
            opt.onEscape = applyContext(context, opt.onEscape);
            opt.callback = applyContext(context, opt.callback);
            applyContextToButtons(opt);
        }
        return opt;
    }

    /**
     * Fixes auto-focusing primary button on long modal.
     * @param  {Object} opt  options to pass to the modal function.
     * @param  {String} type name of the function to use.
     * @return {jQuery}  object of the modal.
     */
    function showModal(opt, type) {
        opt = handleOptions(opt);
        var show = opt.show !== false;
        opt.show = false;
        var $modal = Bootbox[type](opt).off('shown.bs.modal');
        if (show) $modal.modal('show');
        return $modal;
    }

    /**
     * Extending Bootbox to enable easy overriding and context handling.
     */
    var BootboxExtension = _.extend({}, Bootbox, {
        alert: function(opt) {
            return showModal(opt, 'alert');
        },

        confirm: function(opt) {
            return showModal(opt, 'confirm');
        },

        prompt: function(opt) {
            return showModal(opt, 'prompt');
        },

        dialog: function(opt) {
            return showModal(opt, 'dialog');
        }
    });

    /**
     *  Fixes backdrop and scrolling with multiple modals are opened.
     */
    $(document).on({
        'show.bs.modal': function() {
            // Fixes the backdrop z-index with subsequent modals
            var zIndex = 1040 + 10 * $('.modal:visible').length;
            $(this).css('z-index', zIndex);
            _.defer(function() {
                $('.modal-backdrop').not('.modal-stack')
                    .css('z-index', zIndex - 1)
                    .addClass('modal-stack');
            });
        },
        'hidden.bs.modal': function() {
            // Fixes scrolling
            if ($('.modal:visible').length) $(document.body).addClass('modal-open');
        }
    }, '.modal');

    // Fixes multiple callback calls when spamming the enter/esc key or the
    // buttons with mouse clicks.
    // https://github.com/makeusabrew/bootbox/issues/514
    Bootbox.dialog = (function(dialog) {
        return function(options) {
            var modal = dialog(options);
            modal.on("hide.bs.modal", function() {
                modal.off("click escape.close.bb");
            });
            return modal;
        };
    })(Bootbox.dialog);

    return BootboxExtension;
});

